/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.YieldCalculator.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof Any
     */
    '@type': string;
}
/**
 * 
 * @export
 * @interface BenchmarkReplay
 */
export interface BenchmarkReplay {
    /**
     * 
     * @type {Array<EntityInfo>}
     * @memberof BenchmarkReplay
     */
    'items'?: Array<EntityInfo>;
}
/**
 * 
 * @export
 * @interface CapitalMovement
 */
export interface CapitalMovement {
    /**
     * 
     * @type {number}
     * @memberof CapitalMovement
     */
    'date'?: number;
    /**
     * 
     * @type {string}
     * @memberof CapitalMovement
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CapitalMovement
     */
    'ratio'?: number;
    /**
     * 
     * @type {number}
     * @memberof CapitalMovement
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CapitalMovement
     */
    'dividendYield'?: number;
}
/**
 * 
 * @export
 * @interface ChartItem
 */
export interface ChartItem {
    /**
     * 
     * @type {number}
     * @memberof ChartItem
     */
    'date'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChartItem
     */
    'securityValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChartItem
     */
    'benchmarkValue'?: number;
}
/**
 * 
 * @export
 * @interface EntityInfo
 */
export interface EntityInfo {
    /**
     * 
     * @type {string}
     * @memberof EntityInfo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityInfo
     */
    'entityId'?: string;
}
/**
 * 
 * @export
 * @interface FetchBenchmarkReplay
 */
export interface FetchBenchmarkReplay {
    /**
     * 
     * @type {number}
     * @memberof FetchBenchmarkReplay
     */
    'starPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof FetchBenchmarkReplay
     */
    'endPrice'?: number;
}
/**
 * 
 * @export
 * @interface FetchReplay
 */
export interface FetchReplay {
    /**
     * 
     * @type {NumberOfShares}
     * @memberof FetchReplay
     */
    'numberOfSharesTable'?: NumberOfShares;
    /**
     * 
     * @type {ReturnBenchmark}
     * @memberof FetchReplay
     */
    'returnTable'?: ReturnBenchmark;
    /**
     * 
     * @type {Array<CapitalMovement>}
     * @memberof FetchReplay
     */
    'capitalMovementTable'?: Array<CapitalMovement>;
    /**
     * 
     * @type {Array<ChartItem>}
     * @memberof FetchReplay
     */
    'chartItems'?: Array<ChartItem>;
    /**
     * 
     * @type {string}
     * @memberof FetchReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface NumberOfShares
 */
export interface NumberOfShares {
    /**
     * 
     * @type {number}
     * @memberof NumberOfShares
     */
    'startUnit'?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberOfShares
     */
    'startPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberOfShares
     */
    'startTotalAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberOfShares
     */
    'endUnit'?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberOfShares
     */
    'endPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberOfShares
     */
    'endTotalAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberOfShares
     */
    'endDividendPay'?: number;
}
/**
 * 
 * @export
 * @interface ReturnBenchmark
 */
export interface ReturnBenchmark {
    /**
     * 
     * @type {number}
     * @memberof ReturnBenchmark
     */
    'securityTL'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnBenchmark
     */
    'securityUSD'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnBenchmark
     */
    'benchmarkTRL'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnBenchmark
     */
    'benchmarkUSD'?: number;
}
/**
 * 
 * @export
 * @interface ShareReplay
 */
export interface ShareReplay {
    /**
     * 
     * @type {Array<EntityInfo>}
     * @memberof ShareReplay
     */
    'items'?: Array<EntityInfo>;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Any>}
     * @memberof Status
     */
    'details'?: Array<Any>;
}

/**
 * DashboardServiceApi - axios parameter creator
 * @export
 */
export const DashboardServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yieldcalculatorBenchmarksGet: async (identityToken: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('yieldcalculatorBenchmarksGet', 'identityToken', identityToken)
            const localVarPath = `/yieldcalculator/benchmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yieldcalculatorSharesGet: async (identityToken: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('yieldcalculatorSharesGet', 'identityToken', identityToken)
            const localVarPath = `/yieldcalculator/shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardServiceApi - functional programming interface
 * @export
 */
export const DashboardServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yieldcalculatorBenchmarksGet(identityToken: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BenchmarkReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yieldcalculatorBenchmarksGet(identityToken, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yieldcalculatorSharesGet(identityToken: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShareReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yieldcalculatorSharesGet(identityToken, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardServiceApi - factory interface
 * @export
 */
export const DashboardServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yieldcalculatorBenchmarksGet(identityToken: string, culture?: string, options?: any): AxiosPromise<BenchmarkReplay> {
            return localVarFp.yieldcalculatorBenchmarksGet(identityToken, culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yieldcalculatorSharesGet(identityToken: string, culture?: string, options?: any): AxiosPromise<ShareReplay> {
            return localVarFp.yieldcalculatorSharesGet(identityToken, culture, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardServiceApi - object-oriented interface
 * @export
 * @class DashboardServiceApi
 * @extends {BaseAPI}
 */
export class DashboardServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public yieldcalculatorBenchmarksGet(identityToken: string, culture?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).yieldcalculatorBenchmarksGet(identityToken, culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public yieldcalculatorSharesGet(identityToken: string, culture?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).yieldcalculatorSharesGet(identityToken, culture, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QueryServiceApi - axios parameter creator
 * @export
 */
export const QueryServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [benchmarkEntityId] 
         * @param {number} [starDate] 
         * @param {number} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryFetchBenchmarkpriceGet: async (identityToken: string, benchmarkEntityId?: string, starDate?: number, endDate?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('queryFetchBenchmarkpriceGet', 'identityToken', identityToken)
            const localVarPath = `/query/fetch-benchmarkprice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (benchmarkEntityId !== undefined) {
                localVarQueryParameter['benchmarkEntityId'] = benchmarkEntityId;
            }

            if (starDate !== undefined) {
                localVarQueryParameter['starDate'] = starDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [securityEntityId] 
         * @param {string} [benchmarkEntityId] 
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {number} [investment] 
         * @param {number} [numberOfShares] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryFetchDataGet: async (identityToken: string, securityEntityId?: string, benchmarkEntityId?: string, startDate?: number, endDate?: number, investment?: number, numberOfShares?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('queryFetchDataGet', 'identityToken', identityToken)
            const localVarPath = `/query/fetch-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (securityEntityId !== undefined) {
                localVarQueryParameter['securityEntityId'] = securityEntityId;
            }

            if (benchmarkEntityId !== undefined) {
                localVarQueryParameter['benchmarkEntityId'] = benchmarkEntityId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (investment !== undefined) {
                localVarQueryParameter['investment'] = investment;
            }

            if (numberOfShares !== undefined) {
                localVarQueryParameter['numberOfShares'] = numberOfShares;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueryServiceApi - functional programming interface
 * @export
 */
export const QueryServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QueryServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [benchmarkEntityId] 
         * @param {number} [starDate] 
         * @param {number} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryFetchBenchmarkpriceGet(identityToken: string, benchmarkEntityId?: string, starDate?: number, endDate?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchBenchmarkReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryFetchBenchmarkpriceGet(identityToken, benchmarkEntityId, starDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [securityEntityId] 
         * @param {string} [benchmarkEntityId] 
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {number} [investment] 
         * @param {number} [numberOfShares] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryFetchDataGet(identityToken: string, securityEntityId?: string, benchmarkEntityId?: string, startDate?: number, endDate?: number, investment?: number, numberOfShares?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryFetchDataGet(identityToken, securityEntityId, benchmarkEntityId, startDate, endDate, investment, numberOfShares, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QueryServiceApi - factory interface
 * @export
 */
export const QueryServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QueryServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [benchmarkEntityId] 
         * @param {number} [starDate] 
         * @param {number} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryFetchBenchmarkpriceGet(identityToken: string, benchmarkEntityId?: string, starDate?: number, endDate?: number, options?: any): AxiosPromise<FetchBenchmarkReplay> {
            return localVarFp.queryFetchBenchmarkpriceGet(identityToken, benchmarkEntityId, starDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [securityEntityId] 
         * @param {string} [benchmarkEntityId] 
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {number} [investment] 
         * @param {number} [numberOfShares] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryFetchDataGet(identityToken: string, securityEntityId?: string, benchmarkEntityId?: string, startDate?: number, endDate?: number, investment?: number, numberOfShares?: number, options?: any): AxiosPromise<FetchReplay> {
            return localVarFp.queryFetchDataGet(identityToken, securityEntityId, benchmarkEntityId, startDate, endDate, investment, numberOfShares, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QueryServiceApi - object-oriented interface
 * @export
 * @class QueryServiceApi
 * @extends {BaseAPI}
 */
export class QueryServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [benchmarkEntityId] 
     * @param {number} [starDate] 
     * @param {number} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryServiceApi
     */
    public queryFetchBenchmarkpriceGet(identityToken: string, benchmarkEntityId?: string, starDate?: number, endDate?: number, options?: AxiosRequestConfig) {
        return QueryServiceApiFp(this.configuration).queryFetchBenchmarkpriceGet(identityToken, benchmarkEntityId, starDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [securityEntityId] 
     * @param {string} [benchmarkEntityId] 
     * @param {number} [startDate] 
     * @param {number} [endDate] 
     * @param {number} [investment] 
     * @param {number} [numberOfShares] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryServiceApi
     */
    public queryFetchDataGet(identityToken: string, securityEntityId?: string, benchmarkEntityId?: string, startDate?: number, endDate?: number, investment?: number, numberOfShares?: number, options?: AxiosRequestConfig) {
        return QueryServiceApiFp(this.configuration).queryFetchDataGet(identityToken, securityEntityId, benchmarkEntityId, startDate, endDate, investment, numberOfShares, options).then((request) => request(this.axios, this.basePath));
    }
}



